<template>
  <div>
    <h2 class="mb-4">Stock Basket</h2>
    <div class="flex max-w-md font-semibold text-sm sm:text-base">
      <div class="flex-none w-12 sm:w-16 p-1 bg-grey-lightest">
        Ticker
      </div>
      <div class="flex-grow p-1">
        Company name
      </div>
      <div class="flex-none w-12 sm:w-16 p-1 bg-grey-lightest text-right">
        Price
      </div>
      <div class="flex-none w-8 p-1"></div>
    </div>
    <div v-for="(stock, index) in stocks" :key="stock.id" class="flex bg-grey-lightest max-w-md text-sm sm:text-base">
      <div class="flex-none w-12 sm:w-16 p-1 border-t-2 bg-grey-lighter">
        {{ stock.ticker }}
      </div>
      <div class="flex-grow p-1 border-t-2">
        {{ stock.company }}
      </div>
      <div class="flex-none w-12 sm:w-16 p-1 border-t-2 text-right bg-grey-lighter">
        {{ stock.category }}
      </div>
      <div class="flex-none bg-white border-t-2 border-white w-8 p-1 text-center text-grey hover:text-grey-darker cursor-pointer" @click="removeStock(stock.id, index)">
        <i v-if="stock.deleting" class="fas fa-sync fa-spin"></i>
        <i v-else class="fa fa-times"></i>
      </div>
    </div>
    <div v-if="adding" class="flex bg-grey-lightest max-w-md text-sm sm:text-base" @keyup.enter="saveStock">
      <div class="flex-none w-12 sm:w-16 p-1 border-t-2 bg-grey-lighter">
        <input v-focus v-model="newStock.ticker" type="text" class="block w-full bg-grey-lighter" placeholder="TCKR">
      </div>
      <div class="flex-grow p-1 border-t-2">
        <input v-model="newStock.company" type="text" class="block w-full bg-grey-lightest" placeholder="Company Inc.">
      </div>
      <div class="flex-none w-12 sm:w-16 pt-1 pb-1 border-t-2 bg-grey-lighter relative">
        <div class="pointer-events-none absolute pin-y pin-l flex items-center text-grey-light pt-1">
          <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
        </div>
        <select id="grid-state" v-model="newStock.category" class="block appearance-none w-full bg-grey-lighter border border-grey-lighter text-grey-darker rounded pl-3 leading-tight">
          <option></option>
          <option value="> $30">&gt; $30</option>
          <option value="< $30">&lt; $30</option>
        </select>
      </div>
      <div :class="saveButtonClasses" class="flex-none bg-white border-t-2 border-white w-8 p-1 text-center" @click="saveStock">
        <i v-if="saving" class="fas fa-sync fa-spin"></i>
        <i v-else-if="pressingAlt" class="fa fa-times"></i>
        <i v-else class="fa fa-check"></i>
      </div>
    </div>
    <div v-if="!adding" class="flex max-w-md text-sm sm:text-base">
      <div class="flex-none w-12 sm:w-16 p-1 border-t"></div>
      <div class="flex-grow p-1 border-t"></div>
      <div class="flex-none w-12 sm:w-16 p-1 text-base text-center bg-grey-lightest hover:bg-grey-lighter cursor-pointer rounded-b-lg border-t" @click="addLine()">
        + Add
      </div>
      <div class="flex-none w-8 p-1"></div>
    </div>
  </div>
</template>

<script>
import { api } from "arctic-vuejs-template";
export default {
  name: "stock",
  directives: {
    focus: {
      inserted: el => el.focus()
    }
  },
  data() {
    return {
      adding: false,
      pressingAlt: false,
      saving: false,
      stocks: [],
      newStock: {
        ticker: null,
        company: null,
        category: null
      }
    };
  },
  computed: {
    canSave() {
      if (!this.newStock.ticker) return false;
      if (!this.newStock.company) return false;
      if (!this.newStock.category) return false;
      return true;
    },
    saveButtonClasses() {
      if ((!this.saving && this.canSave) || this.pressingAlt)
        return ["cursor-pointer", "text-grey", "hover:text-grey-dark"];
      return ["cursor-not-allowed", "text-grey-light"];
    }
  },
  beforeMount() {
    this.loadStocks();
  },
  mounted() {
    window.addEventListener("keydown", e => {
      if (e.key === "Alt") this.pressingAlt = true;
    });
    window.addEventListener("keyup", e => {
      if (e.key === "Alt") this.pressingAlt = false;
    });
  },
  methods: {
    addLine() {
      this.adding = true;
    },
    loadStocks() {
      this.stocks = [];
      api.get("/stock").then(response => {
        this.stocks = response.data;
      });
    },
    removeStock(id, index) {
      if (this.stocks[index].deleting) return;
      this.$set(this.stocks[index], "deleting", true);
      api.delete(`/stock/${id}`).then(() => this.$delete(this.stocks, index));
    },
    saveStock() {
      if (this.pressingAlt) {
        this.adding = false;
        this.saving = false;
        this.newStock.ticker = null;
        this.newStock.company = null;
        this.newStock.category = null;
        return;
      }
      if (this.saving || !this.canSave) return;
      this.saving = true;
      api.post("/stock", this.newStock).then(response => {
        this.stocks.push(response.data);
        this.adding = false;
        this.saving = false;
        this.newStock.ticker = null;
        this.newStock.company = null;
        this.newStock.category = null;
      });
    }
  }
};
</script>
